// **** Horários ****
// p_horarios.jsx ****
// **** autor: Walcledson de Paula ****
// **** 08-11-24 | 20h19 ****




import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Dock } from 'react-dock'; // Importe o Dock
import Icon from '@mdi/react'; // icone do material design icones pra padronizar o home do mobile/desktop (delphi) no web 2/7/24w
import { mdiStoreSettingsOutline, mdiTimerEditOutline, mdiCommentPlusOutline, mdiClockDigital } from '@mdi/js'; // novo // alterar
import { Oval } from 'react-loader-spinner';
import Swal from "sweetalert2";

import apiaxios from "../../../../../../Services/apiaxios.js";
import handleApiError from "../../../../../../Services/apiErrorHandler.js";
import { decrypt } from "../../../../../../Services/cryptoUtils.js";
import { AutoLogout } from "../../../../../../Services/autologout.js";

import CardFeriado from "../../../../Components/Feriados/p-cardferiado.jsx";
import Menu from '../../../../Components/Menu/p_menu.jsx';
import Footer from '../../../../../AgendexCliente/components/Footer/footer.jsx';

import './p_feriados.css';
import { p_getUserData } from "../../../../../../Services/p_userutils.js";

function Feriados() {
    // verifica se os token's estão presentes e se não são inválidos
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        // const tokenASW = localStorage.getItem("tokenasw");
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    // verifica se é mobile, tablet, nb, pc, etc
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // const [userId, setUserId] = useState(0); // movido lá pra baixo
    const [loading, setLoading] = useState(false);
    const [feriados, setFeriados] = useState([]);
    const [selectedFeriado, setSelectedFeriado] = useState(null);
    const [nenhumFeriadoEncontrado, setNenhumFeriadoEncontrado] = useState(false);
    const [dockOpen, setDockOpen] = useState(false); // Gerencia o estado do Dock
    const [dockOperation, setDockOperation] = useState(""); // Gerencia a operação do Dock
    const openDock = () => setDockOpen(true);
    const closeDock = () => setDockOpen(false); // fechar o dock de dentro do componente p-cardservico.jsx
    const navigate = useNavigate();

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    // const [indEmpresa, setIndEmpresa] = useState(initialUserData.indEmpresa || 0);
    // const [emailValidado, setEmailValidado] = useState(initialUserData.emailValidado || 0);
    const [validado, setValidado] = useState(initialUserData.validado); // CPF/CNPJ validado =1 (se ainda não foi validado = 0)
    const [bloqueio, setBloqueio] = useState(initialUserData.bloqueio); // se contrato vencido ou não (0= não vencido / 1=vencido)

    useEffect(() => {
        if (validado !== 1) {
            Swal.fire('Erro', 'Cadastro em validação... favor aguardar e tentar novamente mais tarde!', 'error');
            navigate('/app/prestador/home');
        } else if (bloqueio !== 0) {
            Swal.fire('Contrato Vencido', 'Cadastro bloqueado. Escolha um de nossos planos para continuar usando o AgendeX', 'error');
            navigate('/app/prestador/home');
        }
    }, [validado, bloqueio, navigate]); // acrescetando 12/9/24w "navigate" pois estava gerando o hint/warning: "Line 147:8:   React Hook useEffect has a missing dependency: 'navigate'. Either include it or remove the dependency array"

    useEffect(() => {
        if (userId) {
            loadFeriados(userId);
        }
    }, [userId]);

    const loadFeriados = async (id_usuario) => {
        try {
            setLoading(true);
            const response = await apiaxios.get(`/servico/FeriadoListarWeb?id_empresa=${id_usuario}&token=${tokenASW}&id_usuario=${id_usuario}`);
            setLoading(false);
            if (response.status === 200 && response.data.length > 0) {
                // console.log('response.data ', response.data);
                setFeriados(response.data);
            } else {
                setNenhumFeriadoEncontrado(true);
            }
        } catch (error) {
            setLoading(false);
            handleApiError(error);
        }
    };


    const handleAlterar = (feriado) => {
        setSelectedFeriado(feriado); // Define o serviço selecionado.
        setDockOperation("edit");
        setDockOpen(true); // Abre o Dock
    };

    const handleAdicionar = () => {
        setDockOperation("add");
        setDockOpen(true); // Abre o Dock
    };

    const handleExcluir = (id_feriado) => {
        // alert('Função excluir');
        Swal.fire({
            title: 'Confirmação',
            text: 'Confirma a exclusão do "Feriado" id #' + id_feriado + ' ?' ,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                fetchExcluirFeriado(id_feriado);
            }
        })
    };

    const toggleRegras = () => {
        navigate('/app/prestador/empresa/regras');
    };

    const toggleHorarios = async () => {
        navigate('/app/prestador/empresa/regras/horarios');
    };



    const fetchExcluirFeriado = async (id_feriado) => {
        setLoading(true);
            try {
                const response = await apiaxios.delete('servico/feriadoExcluirWeb', {
                    params: { id_empresa: userId,
                        id_feriado,
                        token: tokenASW,
                        id_usuario: userId
                    }
                });
                if (response.status === 200) {
                    const data = response.data;
                    if (data.retorno === 'OK') {
                        Swal.fire('Informação', 'Feriado excluído com sucesso!', 'success');
                        loadFeriados(userId);
                    } else {
                        Swal.fire('Erro', data.retorno, 'error');
                    }
                } else { if (response.status !== 200) {
                    const data = response.data;
                    Swal.fire('Erro', data.retorno, 'error');
                    } else {
                        Swal.fire('Erro', 'Falha ao excluir o horário. Tente novamente mais tarde.', 'error');
                    }
                }
            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
    };    



    return (
        <>
            <div className="c_detalheempresa">
                <div className="container-fluid">
                    <div className="row flex-nowrap">
                        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                            <Menu page="regras"/>
                        </div>
                        <div className="col py-3 me-3">
                            <h1 className="text-center">Feriados que não trabalha</h1>
                            <hr />
                            <div className="text-right">
                                <button className="btn btn-info m-2" onClick={toggleHorarios}>
                                    <Icon path={mdiClockDigital} size={1}/> Horários
                                </button>
                                <button className="btn btn-info m-2" onClick={toggleRegras}>
                                    <Icon path={mdiStoreSettingsOutline} size={1}/> Regras
                                </button>
                                <button className="btn btn-success m-2" onClick={handleAdicionar}>
                                    <Icon path={mdiCommentPlusOutline} size={1}/> Novo Feriado
                                </button>
                            </div>
                            {loading ? (
                                <div className="loading-spinner-container">
                                    <Oval color="#00BFFF" height={80} width={80} />
                                </div>
                            ) : (
                                nenhumFeriadoEncontrado ? (
                                    <div className="alert alert-danger mt-2" role="alert">
                                        Nenhum "Feriado" disponível neste momento... comece a cadastrar agora mesmo os feriados que sua empresa não atende(+)
                                    </div>
                                ) : (
                                    <div className="box-explorarempresas">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>Id</th>
                                                    <th>Descrição</th>
                                                    <th>Data</th>
                                                    <th className="text-right">Ações</th>
                                                </tr>
                                            </thead>  
                                            <tbody>
                                                {feriados.map((feriado, index) => (
                                                    <tr key={feriado.ID_FERIADO}>
                                                        <td data-label="Id:">{feriado.ID_FERIADO}</td>
                                                        <td data-label="Descrição:">{feriado.DESCRICAO}</td>
                                                        <td data-label="Data:">{feriado.DIAMES}</td>
                                                        <td className="text-right" data-label="">
                                                            <button className="btn btn-warning m-2" onClick={() => handleAlterar(feriado)}>
                                                                <Icon path={mdiTimerEditOutline} size={1}/> Alterar
                                                            </button>
                                                            <button className="btn btn-danger m-2" onClick={() => handleExcluir(feriado.ID_FERIADO)}>
                                                                <i className="bi bi-trash-fill"></i> Excluir
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            {/* Dock para adicionar/editar Feriados */}
            <Dock 
                position="right" 
                isVisible={dockOpen} 
                // onVisibleChange={(visible) => setDockOpen(visible)} 
                // fluid={false}
                // size={350} // era 370 e estava ficando largo demais em celular tela pequena 26/10/24w14h55 // tamanho da tela em tamanho absoluto em pixels
                fluid={true} 
                size={isMobile ? 0.9 : 0.3} // tamanho da tela em fração de %
            >
                <CardFeriado id_empresa={userId} operacao={dockOperation} feriado={selectedFeriado} openDock={openDock} closeDock={closeDock}/>
            </Dock>
            <Footer />
        </>
    );
}

export default Feriados;